import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { CustomerSelectionOption } from '@app/customer/models/customer-selection-option.model';
import { PanAppState } from '@panamax/app-state';
import { Subscription, take } from 'rxjs';

export type AutopayConfirmationForm = { isValid: boolean; email: string };
export interface AutopayDetails {
  customers: CustomerSelectionOption[];
  bankName: string;
  nickName: string;
  accountNumber: string;
  autoDeductStartDate: Date;
}

@Component({
  selector: 'app-confirm-autopay-details',
  templateUrl: './confirm-autopay-details.component.html',
  styleUrls: ['./confirm-autopay-details.component.scss'],
})
export class ConfirmAutopayDetailsComponent implements OnInit, OnDestroy {
  @Input() autopayDetails: AutopayDetails;
  @Input() isDesktop: boolean;
  @Output() setConfirmationValidEmit =
    new EventEmitter<AutopayConfirmationForm>();
  autopayChangesSub$: Subscription;
  email: string;
  confirmationAutopayForm: FormGroup;
  isValidForm = false;
  showAllCustomers = false;
  constructor(
    private fb: FormBuilder,
    private panAppState: PanAppState,
  ) {}

  ngOnInit() {
    this.createForm();
    this.panAppState.user$.pipe(take(1)).subscribe(user => {
      this.email = user.email;
    });
  }

  createForm(): void {
    this.confirmationAutopayForm = this.fb.group({
      fullName: new FormControl('', Validators.required),
      emailNotification: new FormControl(false),
      agreementCheckbox: new FormControl(false, {
        validators: Validators.requiredTrue,
      }),
    });

    this.autopayChangesSub$ =
      this.confirmationAutopayForm.valueChanges.subscribe(value => {
        this.isValidForm = this.confirmationAutopayForm.valid;
        this.setAutopayDetailsForm(
          this.confirmationAutopayForm.valid,
          value.emailNotification,
        );
      });
  }

  setAutopayDetailsForm(isValid: boolean, emailNotification: boolean): void {
    this.setConfirmationValidEmit.emit({
      isValid,
      email: emailNotification ? this.email : '',
    });
  }

  ngOnDestroy(): void {
    this.setAutopayDetailsForm(false, false);
    this.autopayChangesSub$.unsubscribe();
  }

  get fullNameControl(): FormControl {
    return this.confirmationAutopayForm.get('fullName') as FormControl;
  }

  get emailNotificationControl(): FormControl {
    return this.confirmationAutopayForm.get('emailNotification') as FormControl;
  }
}
